/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Policy_NumberInputs */

const en_wallet_card_policy_number = /** @type {(inputs: Wallet_Card_Policy_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy Number`)
};

const fr_wallet_card_policy_number = /** @type {(inputs: Wallet_Card_Policy_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numéro de police`)
};

/**
* | output |
* | --- |
* | "Policy Number" |
*
* @param {Wallet_Card_Policy_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_policy_number = /** @type {((inputs?: Wallet_Card_Policy_NumberInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Policy_NumberInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_policy_number(inputs)
	return fr_wallet_card_policy_number(inputs)
});